<template>
    <div class="print-form">
        <div class="text-center">
            <h2>{{doctor.clinic_name}}</h2>
            <p>{{doctor.field}}</p>
            <p>{{doctor.clinic_address}}</p>
            <p>Clinic Hours: {{doctor.business_hours}}</p>
            <p>Telephone No.: {{doctor.clinic_tel_number}} Email: {{user.email}}</p>
        </div>
        <hr>

        <div class="d-flex justify-content-between pl-5 pr-5">
            <p><strong>Name:</strong> {{patient.first_name}} {{patient.last_name}}</p>
            <p><strong>Date:</strong> {{ currentDate }}</p>
        </div>
        <div class="d-flex pl-5 pr-5">
            <p class="align-self-start"><strong>Age:</strong> {{patient.age}}</p>
            <p>&nbsp;</p>
        </div>

        <div class="mt-5 clearfix">
            <h1>Rx</h1>
            <div class="d-flex">
                <b-table small bordered :items="prescriptions" :fields="fields">
                    <span slot="medicine" slot-scope="data">
                        {{data.item.medicine.name}}
                    </span>
                </b-table>
            </div>
            <div class="d-flex align-items-end justify-content-between">
                <div class="mt-5">
                    <p><strong>{{`${user.doctor.first_name} ${user.doctor.last_name}` }}</strong></p>
                    <p>License no: <strong>{{user.doctor.license_number}}</strong></p>
                    <p>PTR no: <strong>{{user.doctor.ptr_number}}</strong></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      patient: {
        type: Object
      },
      user: {
        type: Object
      },
      settings: {
        type: Object
      },
      prescriptions: {
        type: Object
      }
    },
    computed: {
      currentDate() {
        return moment().format('Y-MM-DD');
      },
      doctor() {
        return this.user.doctor;
      }
    },

    data() {
      return {
        fields: [
          'medicine',
          'frequency',
          'dosage',
          'quantity'
        ]
      };
    }
  }
</script>

<style lang="scss" scoped>
    .print-form {
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/views/Prescription/RxPrintedForm.vue